export default __webpack_public_path__ + "static/kronen-zeitung-2abee190f64bf729532695cb8e710148.svg";